import youngImg from "@/assets/img/both-age-groups/18-29.webp";
import bodyScanBothYoungImg from "@/assets/img/both-age-groups/18-29-body-scan.webp";
import youngColorfulImg from "@/assets/img/both-age-groups/18-29-colorful.webp";
import midAgeImg from "@/assets/img/both-age-groups/30-39.webp";
import bodyScanBothMidAgeImg from "@/assets/img/both-age-groups/30-39-body-scan.webp";
import midAgeColorfulImg from "@/assets/img/both-age-groups/30-39-colorful.webp";
import adultImg from "@/assets/img/both-age-groups/40-49.webp";
import bodyScanBothAdultImg from "@/assets/img/both-age-groups/40-49-body-scan.webp";
import seniorImg from "@/assets/img/both-age-groups/50.webp";
import bodyScanBothSeniorImg from "@/assets/img/both-age-groups/50-body-scan.webp";
import newWeightLossYoungImg from "@/assets/img/both-age-groups/new-weightloss-18-29.webp";
import newWeightLossMidAgeImg from "@/assets/img/both-age-groups/new-weightloss-30-39.webp";
import newWeightLossAdultImg from "@/assets/img/both-age-groups/new-weightloss-40-49.webp";
import newWeightLossSeniorImg from "@/assets/img/both-age-groups/new-weightloss-50.webp";
import weightLossYoungImg from "@/assets/img/both-age-groups/weightloss-18-29.webp";
import weightLossMidAgeImg from "@/assets/img/both-age-groups/weightloss-30-39.webp";
import weightLossAdultImg from "@/assets/img/both-age-groups/weightloss-40-49.webp";
import weightLossSeniorImg from "@/assets/img/both-age-groups/weightloss-50.webp";
import { QUESTIONS_IDS } from "@/constants/questionsIds";
import { Routes as AppRoutes } from "@/constants/routes";
import femaleYoungImg from "@/female/assets/age-groups/18-29.webp";
import femaleMidAgeImg from "@/female/assets/age-groups/30-39.webp";
import femaleAdultImg from "@/female/assets/age-groups/40-49.webp";
import femaleSeniorImg from "@/female/assets/age-groups/50.webp";
import seniorsGroup1FemaleImg from "@/female/assets/age-groups/seniors/40-49.webp";
import seniorsGroup2FemaleImg from "@/female/assets/age-groups/seniors/50-59.webp";
import seniorsGroup3FemaleImg from "@/female/assets/age-groups/seniors/60-69.webp";
import seniorsGroup4FemaleImg from "@/female/assets/age-groups/seniors/70.webp";
import absBodyScanFemaleYoungImg from "@/female/assets/body-scan-funnel/abs-age-groups/18-29.webp";
import absBodyScanFemaleMidAgeImg from "@/female/assets/body-scan-funnel/abs-age-groups/30-39.webp";
import absBodyScanFemaleAdultImg from "@/female/assets/body-scan-funnel/abs-age-groups/40-49.webp";
import absBodyScanFemaleSeniorImg from "@/female/assets/body-scan-funnel/abs-age-groups/50.webp";
import bodyScanFemaleYoungImg from "@/female/assets/body-scan-funnel/age-groups/18-29.webp";
import bodyScanFemaleMidAgeImg from "@/female/assets/body-scan-funnel/age-groups/30-39.webp";
import bodyScanFemaleAdultImg from "@/female/assets/body-scan-funnel/age-groups/40-49.webp";
import bodyScanFemaleSeniorImg from "@/female/assets/body-scan-funnel/age-groups/50.webp";
import i18n from "@/localization/i18next";
import maleYoungImg from "@/male/assets/age-groups/18-29.webp";
import maleMidAgeImg from "@/male/assets/age-groups/30-39.webp";
import maleAdultImg from "@/male/assets/age-groups/40-49.webp";
import maleSeniorImg from "@/male/assets/age-groups/50.webp";
import absBodyScanMaleYoungImg from "@/male/assets/body-scan-funnel/abs-age-groups/18-29.webp";
import absBodyScanMaleMidAgeImg from "@/male/assets/body-scan-funnel/abs-age-groups/30-39.webp";
import absBodyScanMaleAdultImg from "@/male/assets/body-scan-funnel/abs-age-groups/40-49.webp";
import absBodyScanMaleSeniorImg from "@/male/assets/body-scan-funnel/abs-age-groups/50.webp";
import bodyScanMaleYoungImg from "@/male/assets/body-scan-funnel/age-groups/18-29.webp";
import bodyScanMaleMidAgeImg from "@/male/assets/body-scan-funnel/age-groups/30-39.webp";
import bodyScanMaleAdultImg from "@/male/assets/body-scan-funnel/age-groups/40-49.webp";
import bodyScanMaleSeniorImg from "@/male/assets/body-scan-funnel/age-groups/50.webp";
import { localStorageManager, LocalStorageManagerKeys } from "@/utils/localStorageManager";

export const enum ScreenType {
    Workout = "workout",
    Lift = "lift",
    WeightLoss = "weightloss",
    NewWeightLoss = "newWeightLoss",
    Pilates = "pilates",
    Calisthenics = "calisthenics",
    BodyScan = "bodyScan",
    BodyScanAbs = "bodyScanAbs",
    Seniors = "seniors",
}

export const getScreenType = (route?: string) => {
    let type = ScreenType.Workout;

    if (route) {
        type =
            {
                [AppRoutes.AgeWorkout]: ScreenType.Workout,
                [AppRoutes.CreoTests]: ScreenType.Workout,
                [AppRoutes.HighIntent]: ScreenType.Workout,
                [AppRoutes.AgeWeightLoss]: ScreenType.WeightLoss,
                [AppRoutes.WeightLoss]: ScreenType.NewWeightLoss,
                [AppRoutes.AgeLift]: ScreenType.Lift,
                [AppRoutes.Pilates]: ScreenType.Pilates,
                [AppRoutes.CalisthenicsAge]: ScreenType.Calisthenics,
                [AppRoutes.BodyScan]: ScreenType.BodyScan,
                [AppRoutes.BodyScanAbs]: ScreenType.BodyScanAbs,
                [AppRoutes.BodyScanPlans]: ScreenType.BodyScan,
                [AppRoutes.BodyScanPlansApplovin]: ScreenType.BodyScan,
                [AppRoutes.Seniors]: ScreenType.Seniors,
                [AppRoutes.SeniorsApplovin]: ScreenType.Seniors,
            }[route] ?? ScreenType.Workout;
    }

    return type;
};

export const titleByType = (isBothOrGLP1: boolean) => ({
    [ScreenType.Workout]: i18n.t("personal_workout_plan"),
    [ScreenType.Lift]: "Weightlifting program",
    [ScreenType.WeightLoss]: "Lose Weight program",
    [ScreenType.NewWeightLoss]: (
        <span>
            Personal Weight Loss
            <br />
            Plan
        </span>
    ),
    [ScreenType.Pilates]: "Wall Pilates Program",
    [ScreenType.Calisthenics]: "Personal calisthenics workout plan",
    [ScreenType.BodyScan]: isBothOrGLP1 ? (
        "Your Personal Body Scan Workout Plan"
    ) : (
        <span>
            AI Body Scan
            <br />
            Workout Plan
        </span>
    ),
    [ScreenType.BodyScanAbs]: (
        <span>
            Body Scan
            <br />
            Abs Workout Plan
        </span>
    ),
    [ScreenType.Seniors]: "Personal AI Indoor workout plan",
});

export const enum AgeGroup {
    Young = "18-29",
    Mid = "30-39",
    Adult = "40-49",
    Senior = "50+",
}

export const enum SeniorsAgeGroups {
    Forties = "40-49",
    Fifties = "50-59",
    Sixties = "60-69",
    Seventies = "70+",
}

export const DecadeByAgeGroup = {
    [AgeGroup.Young]: "20s",
    [AgeGroup.Mid]: "30s",
    [AgeGroup.Adult]: "40s",
    [AgeGroup.Senior]: "50s",
};

export const SeniorsDecadeByAgeGroup = {
    [SeniorsAgeGroups.Forties]: "40s",
    [SeniorsAgeGroups.Fifties]: "50s",
    [SeniorsAgeGroups.Sixties]: "60s",
    [SeniorsAgeGroups.Seventies]: "70s",
};

// Backend-allowed age_group values
export const enum BackendAgeGroup {
    Twenties = "twenties",
    Thirties = "thirties",
    Forties = "forties",
    Fifties = "fifties",
    Sixties = "sixties",
}

// Maps frontend age group values to backend-allowed values
export const AgeGroupToBackendMap: Record<string, BackendAgeGroup> = {
    [AgeGroup.Young]: BackendAgeGroup.Twenties, // "18-29"
    [AgeGroup.Mid]: BackendAgeGroup.Thirties, // "30-39"
    [AgeGroup.Adult]: BackendAgeGroup.Forties, // "40-49"
    [AgeGroup.Senior]: BackendAgeGroup.Fifties, // "50+"
    [SeniorsAgeGroups.Fifties]: BackendAgeGroup.Fifties, // "50-59"
    [SeniorsAgeGroups.Sixties]: BackendAgeGroup.Sixties, // "60-69"
    [SeniorsAgeGroups.Seventies]: BackendAgeGroup.Sixties, // "70+" -> closest backend value
};

/**
 * Maps frontend age group value to backend-allowed age_group value.
 * Returns the mapped value or null if no mapping exists.
 */
export const mapAgeGroupToBackend = (ageGroup: string | undefined): BackendAgeGroup | null => {
    if (!ageGroup) return null;
    return AgeGroupToBackendMap[ageGroup] ?? null;
};

/**
 * Helper function to get decade value from answers or fallback to local storage
 * @param answers - The answers object
 * @returns The decade string (e.g., "20s", "30s") or empty string if not found
 */
export const getDecadeValue = (answers: Record<string, unknown>): string => {
    const ageGroup = answers[QUESTIONS_IDS.AGE_GROUP];

    // Try regular age groups first
    if (ageGroup && typeof ageGroup === "string" && ageGroup in DecadeByAgeGroup) {
        return DecadeByAgeGroup[ageGroup as AgeGroup];
    }

    // Try seniors age groups
    if (ageGroup && typeof ageGroup === "string" && ageGroup in SeniorsDecadeByAgeGroup) {
        return SeniorsDecadeByAgeGroup[ageGroup as SeniorsAgeGroups];
    }

    // Fallback to local storage if answer is empty
    const storedDecade = localStorageManager.getStoredItem<string>(
        LocalStorageManagerKeys.AGE_GROUP_DECADE
    );
    return storedDecade || "";
};

export const ageGroupsArr = [AgeGroup.Young, AgeGroup.Mid, AgeGroup.Adult, AgeGroup.Senior];
export const seniorsAgeGroupsArr = [
    SeniorsAgeGroups.Forties,
    SeniorsAgeGroups.Fifties,
    SeniorsAgeGroups.Sixties,
    SeniorsAgeGroups.Seventies,
];

export const defaultBothAgeGroupsImgs = {
    [AgeGroup.Young]: youngImg,
    [AgeGroup.Mid]: midAgeImg,
    [AgeGroup.Adult]: adultImg,
    [AgeGroup.Senior]: seniorImg,
};

const colorfulBothAgeGroupsImgs = {
    [AgeGroup.Young]: youngColorfulImg,
    [AgeGroup.Mid]: midAgeColorfulImg,
    [AgeGroup.Adult]: adultImg,
    [AgeGroup.Senior]: seniorImg,
};

const weightLossBothAgeGroupsImgs = {
    [AgeGroup.Young]: weightLossYoungImg,
    [AgeGroup.Mid]: weightLossMidAgeImg,
    [AgeGroup.Adult]: weightLossAdultImg,
    [AgeGroup.Senior]: weightLossSeniorImg,
};

const newWeightLossBothAgeGroupsImgs = {
    [AgeGroup.Young]: newWeightLossYoungImg,
    [AgeGroup.Mid]: newWeightLossMidAgeImg,
    [AgeGroup.Adult]: newWeightLossAdultImg,
    [AgeGroup.Senior]: newWeightLossSeniorImg,
};

const bodyScanBothAgeGroupsImgs = {
    [AgeGroup.Young]: bodyScanBothYoungImg,
    [AgeGroup.Mid]: bodyScanBothMidAgeImg,
    [AgeGroup.Adult]: bodyScanBothAdultImg,
    [AgeGroup.Senior]: bodyScanBothSeniorImg,
};

const femaleAgeGroupsImgs = {
    [AgeGroup.Young]: femaleYoungImg,
    [AgeGroup.Mid]: femaleMidAgeImg,
    [AgeGroup.Adult]: femaleAdultImg,
    [AgeGroup.Senior]: femaleSeniorImg,
};

const maleAgeGroupsImgs = {
    [AgeGroup.Young]: maleYoungImg,
    [AgeGroup.Mid]: maleMidAgeImg,
    [AgeGroup.Adult]: maleAdultImg,
    [AgeGroup.Senior]: maleSeniorImg,
};

const bodyScanFemaleAgeGroupsImgs = {
    [AgeGroup.Young]: bodyScanFemaleYoungImg,
    [AgeGroup.Mid]: bodyScanFemaleMidAgeImg,
    [AgeGroup.Adult]: bodyScanFemaleAdultImg,
    [AgeGroup.Senior]: bodyScanFemaleSeniorImg,
};

const absBodyScanFemaleAgeGroupsImgs = {
    [AgeGroup.Young]: absBodyScanFemaleYoungImg,
    [AgeGroup.Mid]: absBodyScanFemaleMidAgeImg,
    [AgeGroup.Adult]: absBodyScanFemaleAdultImg,
    [AgeGroup.Senior]: absBodyScanFemaleSeniorImg,
};

const bodyScanMaleAgeGroupsImgs = {
    [AgeGroup.Young]: bodyScanMaleYoungImg,
    [AgeGroup.Mid]: bodyScanMaleMidAgeImg,
    [AgeGroup.Adult]: bodyScanMaleAdultImg,
    [AgeGroup.Senior]: bodyScanMaleSeniorImg,
};

const absBodyScanMaleAgeGroupsImgs = {
    [AgeGroup.Young]: absBodyScanMaleYoungImg,
    [AgeGroup.Mid]: absBodyScanMaleMidAgeImg,
    [AgeGroup.Adult]: absBodyScanMaleAdultImg,
    [AgeGroup.Senior]: absBodyScanMaleSeniorImg,
};

const seniorsFemaleAgeGroupsImgs = {
    [SeniorsAgeGroups.Forties]: seniorsGroup1FemaleImg,
    [SeniorsAgeGroups.Fifties]: seniorsGroup2FemaleImg,
    [SeniorsAgeGroups.Sixties]: seniorsGroup3FemaleImg,
    [SeniorsAgeGroups.Seventies]: seniorsGroup4FemaleImg,
};

export const getAgeGroupsImgs = (
    type: ScreenType,
    isBothOrGLP1: boolean,
    isFemale: boolean,
    route?: string
) => {
    if (isBothOrGLP1) {
        const needsColorfulImg = route === AppRoutes.Base || type === ScreenType.Calisthenics;

        if (needsColorfulImg) return colorfulBothAgeGroupsImgs;
        if (type === ScreenType.BodyScan) return bodyScanBothAgeGroupsImgs;
        if (type === ScreenType.WeightLoss) return weightLossBothAgeGroupsImgs;
        if (type === ScreenType.NewWeightLoss) return newWeightLossBothAgeGroupsImgs;

        return defaultBothAgeGroupsImgs;
    } else if (type === ScreenType.BodyScan) {
        return isFemale ? bodyScanFemaleAgeGroupsImgs : bodyScanMaleAgeGroupsImgs;
    } else if (type === ScreenType.BodyScanAbs) {
        return isFemale ? absBodyScanFemaleAgeGroupsImgs : absBodyScanMaleAgeGroupsImgs;
    } else if (type === ScreenType.Seniors && isFemale) {
        return seniorsFemaleAgeGroupsImgs;
    }

    return isFemale ? femaleAgeGroupsImgs : maleAgeGroupsImgs;
};
